import { api } from "@/lib/api";

import type {
  CreateProductReq,
  Product,
  ProductList,
  UpdateProductReq,
} from "@artisancode/api-types";

export interface ProductListParams {
  page?: number;
  per_page?: number;
  q?: string;
  category?: string;
  menu_group?: string;
  workspace_id?: string;
}

export const productService = {
  list: (params?: ProductListParams) =>
    api.get<ProductList>(
      "/products",
      params as Record<string, string | number | boolean | undefined>,
    ),

  create: (body: CreateProductReq) => api.post<Product>("/products", body),

  update: (id: string, body: UpdateProductReq) =>
    api.put<Product>(`/products/${id}`, body),
};
